import { Navigate, Route, Routes } from "react-router-dom";
import LandingLayout from "./components/LandingLayout.js";
import WelcomePage from "./pages/WelcomePage.js";
import AboutPage from "./pages/AboutPage.js";
import RoadmapPage from "./pages/RoadmapPage.js";
import TermsPage from "./pages/TermsPage.js";
import NewsPage from "./pages/NewsPage.js";
import ClosedAlphaLaunchPage from "./pages/ClosedAlphaLaunchPage.js";

const LandingRoutes = () => (
  <Routes>
    <Route element={<LandingLayout />}>
      <Route index element={<WelcomePage />} />
      <Route path="about" element={<AboutPage />} />
      <Route path="roadmap" element={<RoadmapPage />} />
      <Route path="terms" element={<TermsPage />} />
      <Route path="news" element={<NewsPage />} />
      <Route path="news/closed-alpha-launch" element={<ClosedAlphaLaunchPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>
  </Routes>
);

export default LandingRoutes;
